import { createStore, applyMiddleware, combineReducers } from "redux";
import ReduxThunk from "redux-thunk";

import appReducer from "../Reducers/AppReducer";
import categoryReducer from "Redux/Reducers/CategoryReducer";
import authReducer from "Redux/Reducers/AuthReducer";
import BlogReduser from "Redux/Reducers/BlogReduser";

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  category: categoryReducer,
  blog: BlogReduser,
});

export const ReduxStore = createStore(rootReducer, applyMiddleware(ReduxThunk));
